(() => {
	const root = document.querySelector('.icreo-birthday');
	if (!root) return;

	const messageImages = root.querySelectorAll('[data-message-image]');
	if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		root.classList.add('message-reveal-ready');
		const messageObserver = 'IntersectionObserver' in window
			? new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					entry.target.classList.add('is-visible');
					messageObserver.unobserve(entry.target);
				});
			}, { threshold: 0.15 })
			: null;
		messageImages.forEach((image) => messageObserver?.observe(image));
		const revealVisibleImages = () => {
			messageImages.forEach((image) => {
				const bounds = image.getBoundingClientRect();
				const visibleHeight = Math.max(0, Math.min(bounds.bottom, window.innerHeight) - Math.max(bounds.top, 0));
				if (bounds.height === 0 || visibleHeight / bounds.height < 0.15) return;
				image.classList.add('is-visible');
				messageObserver?.unobserve(image);
			});
		};
		window.addEventListener('scroll', revealVisibleImages, { passive: true });
		window.addEventListener('resize', revealVisibleImages);
		window.addEventListener('pageshow', revealVisibleImages, { once: true });
		revealVisibleImages();
	}

	const couponButton = root.querySelector('[data-copy-coupon]');
	const copyStatus = root.querySelector('[data-copy-status]');
	const defaultCopyStatus = copyStatus.textContent;
	let copyStatusTimer;
	couponButton?.addEventListener('click', async () => {
		try {
			await navigator.clipboard.writeText('ICL1BIR4B2P');
			clearTimeout(copyStatusTimer);
			copyStatus.textContent = 'クーポンコードをコピーしました。';
			copyStatusTimer = setTimeout(() => {
				copyStatus.textContent = defaultCopyStatus;
			}, 3000);
		} catch {
			clearTimeout(copyStatusTimer);
			copyStatus.textContent = 'クーポンコード：ICL1BIR4B2P';
		}
	});

	const arButton = root.querySelector('.ar-main__button');
	const arStatus = root.querySelector('#ar-access-status');
	const isSmartphone = navigator.userAgentData?.mobile ?? /iPhone|iPod|Android.*Mobile/i.test(navigator.userAgent);
	if (arButton && arStatus && !isSmartphone) {
		arButton.removeAttribute('href');
		arButton.setAttribute('role', 'button');
		arButton.setAttribute('tabindex', '0');
		let arStatusTimer;
		arButton.addEventListener('click', (event) => {
			event.preventDefault();
			clearTimeout(arStatusTimer);
			arStatus.textContent = 'ー PCからはアクセスできません ー';
			arStatusTimer = setTimeout(() => {
				arStatus.textContent = '';
			}, 3000);
		});
		arButton.addEventListener('keydown', (event) => {
			if (event.key !== 'Enter' && event.key !== ' ') return;
			event.preventDefault();
			arButton.click();
		});
	}

	const dialog = root.querySelector('[data-rules-dialog]');
	root.querySelector('[data-open-rules]')?.addEventListener('click', () => dialog?.showModal());
	root.querySelector('[data-close-rules]')?.addEventListener('click', () => dialog?.close());
	dialog?.addEventListener('click', (event) => {
		if (event.target === dialog) dialog.close();
	});
})();